const SAFE_COLOR = /^(?:#[0-9a-f]{3,4}|#[0-9a-f]{6}|#[0-9a-f]{8}|rgba?\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*(?:,\s*(?:0|1|0?\.\d+)\s*)?\)|[a-z]{3,20})$/i;

export function getSafeColor(value: string | null): string | null {
  if (!value || value.length > 40 || !SAFE_COLOR.test(value)) {
    return null;
  }

  if (typeof CSS !== "undefined" && typeof CSS.supports === "function") {
    return CSS.supports("color", value) ? value : null;
  }

  if (typeof document !== "undefined") {
    const style = document.createElement("span").style;
    style.color = value;
    return style.color ? value : null;
  }

  return null;
}
